import { createSlice } from '@reduxjs/toolkit';
import { sortBy } from 'lodash';
import moment from 'moment';
import { Completed, Deactivated, Live, Scheduled } from '../../constants/NotificationsConst';
import {
  getAllInRoomDining,
  getServiceRequestDetails,
  getAllInRoomDiningMenu,
  getAllTelephony,
  getCampaignNotifications,
} from '../../utils/ServicesAPIUtils';
import { getEmailServicesList } from '../../utils/cmsUtils';
import { decryptLocalStorage } from '../../utils/authUtils';
import { logError } from '../../utils/commonUtils';
import { ENVIRONMENT } from '../../env/Configurations';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../utils/loaderSlice';
export const servicesSlice = createSlice({
  name: 'services',
  initialState: {
    inRoomDiningLoader: false,
    inRoomDiningMenu: [],
    inRoomDiningCategory: [],
    inRoomDiningCombos: [],
    inRoomDiningItems: [],
    inRoomDiningCustomisations: [],
    inRoomDiningAddOn: [],
    inRoomDiningOns: [],
    inRoomDiningTags: [],
    inRoomDiningAllergens: [],
    inRoomDiningDiscounts: [],
    inRoomDiningKinds: [],
    inRoomDiningError: null,
    serviceRequestLoader: false,
    serviceRequest: [],
    serviceRequestHouseKeeping: [],
    serviceRequestConcierge: [],
    serviceRequestError: null,
    posMenu: null,
    menuType: null,
    menuFormData: {},
    isPublished: false,
    menuId: null,
    telephonyDirectories: [],
    telephonyExtensions: [],
    notificationCampaign: [],
    emailServices: [],
  },
  reducers: {
    setInRoomDining: (state, action) => {
      state.inRoomDiningCategory = [];
      state.inRoomDiningCombos = [];
      state.inRoomDiningItems = [];
      state.inRoomDiningCustomisations = [];
      state.inRoomDiningAddOn = [];
      state.inRoomDiningTags = [];
      state.inRoomDiningAllergens = [];
      state.inRoomDiningDiscounts = [];
      state.inRoomDiningKinds = [];
      state.allRestaurantLoader = false;
      state.inRoomDiningError = null;
    },
    setIRDMenu: (state, action) => {
      state.inRoomDiningMenu = [];
    },
    setInRoomDiningMenu: (state, action) => {
      state.inRoomDiningMenu = action.payload;
    },
    setInRoomDiningCategory: (state, action) => {
      state.inRoomDiningCategory = action.payload;
    },
    setInRoomDiningCombo: (state, action) => {
      state.inRoomDiningCombos = action.payload;
    },
    setInRoomDiningItems: (state, action) => {
      state.inRoomDiningItems = action.payload;
    },
    setInRoomDiningCustomisations: (state, action) => {
      state.inRoomDiningCustomisations = action.payload;
    },
    setInRoomDiningAddOn: (state, action) => {
      state.inRoomDiningAddOn = action.payload;
    },
    setInRoomDiningTags: (state, action) => {
      state.inRoomDiningTags = action.payload;
    },
    setInRoomDiningAllergens: (state, action) => {
      state.inRoomDiningAllergens = action.payload;
    },
    setInRoomDiningDiscounts: (state, action) => {
      state.inRoomDiningDiscounts = action.payload;
    },
    setInRoomDiningKinds: (state, action) => {
      state.inRoomDiningKinds = action.payload;
    },
    setInRoomDiningSuccess: (state) => {
      state.allRestaurantLoader = false;
      state.inRoomDiningError = null;
    },
    setInRoomDiningError: (state, action) => {
      state.allRestaurantLoader = false;
      state.inRoomDiningError = action.payload;
    },
    setServiceRequest: (state, action) => {
      state.serviceRequestHouseKeeping = [];
      state.serviceRequestConcierge = [];
      state.serviceRequestError = null;
      state.serviceRequestLoader = false;
    },
    setHouseKeeping: (state, action) => {
      state.serviceRequestHouseKeeping = action.payload;
    },
    setConcierge: (state, action) => {
      state.serviceRequestConcierge = action.payload;
    },
    setServiceRequestSuccess: (state) => {
      state.serviceRequestLoader = false;
      state.serviceRequestError = null;
    },
    setServiceRequestError: (state, action) => {
      state.serviceRequestLoader = false;
      state.serviceRequestError = action.payload;
    },
    getPosMenu: (state, action) => {
      state.posMenu = action.payload;
    },
    getMenuFormData: (state, action) => {
      state.menuFormData = action.payload;
    },
    setIsPublished: (state, action) => {
      state.isPublished = action.payload;
    },
    setMenuType: (state, action) => {
      state.menuType = action.payload;
    },
    setMenuId: (state, action) => {
      state.menuId = action.payload;
    },
    setDirectory: (state, action) => {
      state.telephonyDirectories = [];
      state.telephonyExtensions = [];
    },
    setTelephonyDirectory: (state, action) => {
      state.telephonyDirectories = action.payload;
    },
    setTelephonyExtensions: (state, action) => {
      state.telephonyExtensions = action.payload;
    },
    setNotificationCampaign: (state, action) => {
      state.notificationCampaign = action.payload;
    },
    setEmailServices: (state, action) => {
      state.emailServices = action.payload;
    },
  },
});

export const {
  setInRoomDining,
  setIRDMenu,
  setMenuType,
  setInRoomDiningMenu,
  setInRoomDiningCategory,
  setInRoomDiningCombo,
  setInRoomDiningItems,
  setInRoomDiningCustomisations,
  setInRoomDiningAddOn,
  setInRoomDiningTags,
  setInRoomDiningAllergens,
  setInRoomDiningDiscounts,
  setInRoomDiningKinds,
  setInRoomDiningSuccess,
  setInRoomDiningError,
  setServiceRequest,
  setHouseKeeping,
  setConcierge,
  setServiceRequestSuccess,
  setServiceRequestError,
  getPosMenu,
  getMenuFormData,
  setIsPublished,
  setMenuId,
  setTelephonyDirectory,
  setTelephonyExtensions,
  setNotificationCampaign,
  setEmailServices,
} = servicesSlice.actions;

export const fetchAllInRoomDining = (hotelId, restaurantId) => async (dispatch) => {
  try {
    dispatch(stepUpLoaderCount());
    const lang = decryptLocalStorage('lang');
    const getByLang = lang !== 'en' ? lang : '';
    dispatch(setInRoomDining());
    const res = await getAllInRoomDining(hotelId, restaurantId, getByLang);
    dispatch(setInRoomDiningCategory(res.data.getIRDDetails.categories));
    dispatch(setInRoomDiningCombo(res.data.getIRDDetails.bundles));
    dispatch(setInRoomDiningItems(res.data.getIRDDetails.items));
    dispatch(setInRoomDiningCustomisations(res.data.getIRDDetails.customisations));
    dispatch(setInRoomDiningAddOn(res.data.getIRDDetails.addons));
    dispatch(setInRoomDiningTags(res.data.getIRDDetails.tags));
    dispatch(setInRoomDiningAllergens(res.data.getIRDDetails.allergens));
    dispatch(setInRoomDiningDiscounts(res.data.getIRDDetails.discounts));
    dispatch(
      setInRoomDiningKinds(
        sortBy(res.data.getIRDDetails.kinds, [(kind) => kind.name.toLowerCase()]),
      ),
    );
  } catch (error) {
    logError(hotelId, 'fetchAllInRoomDining', error?.message);

    if (ENVIRONMENT === 'dev') {
      console.log(error?.message);
    }
    return false;
  } finally {
    dispatch(stepDownLoaderCount());
  }
};

export const fetchAllInRoomDiningMenu = (hotelId, restaurantId) => async (dispatch) => {
  try {
    dispatch(stepUpLoaderCount());
    const lang = decryptLocalStorage('lang');
    const getByLang = lang !== 'en' ? lang : '';
    const res = await getAllInRoomDiningMenu(hotelId, restaurantId, getByLang);
    dispatch(setInRoomDiningMenu(res.data.getIRDMenuDetails));
  } catch (error) {
    logError(hotelId, 'fetchAllInRoomDiningMenu', error?.message);

    if (ENVIRONMENT === 'dev') {
      console.log(error?.message);
    }
    return false;
  } finally {
    dispatch(stepDownLoaderCount());
  }
};

export const fetchAllServiceReqeust = (hotelId) => async (dispatch) => {
  try {
    dispatch(stepUpLoaderCount());
    const lang = decryptLocalStorage('lang');
    const getByLang = lang !== 'en' ? lang : '';
    const res = await getServiceRequestDetails(hotelId, getByLang);
    dispatch(setHouseKeeping(res.data.getServiceRequestDetails.houseKeeping));
    dispatch(setConcierge(res.data.getServiceRequestDetails.concierge));
  } catch (error) {
    logError(hotelId, 'fetchAllServiceReqeust', error?.message);

    if (ENVIRONMENT === 'dev') {
      console.log(error?.message);
    }
  } finally {
    dispatch(stepDownLoaderCount());
  }
};

export const fetchAllTelephonyDetails = (hotelId) => async (dispatch) => {
  try {
    dispatch(stepUpLoaderCount());
    const lang = decryptLocalStorage('lang');
    const getByLang = lang !== 'en' ? lang : '';
    const res = await getAllTelephony(hotelId, getByLang);
    dispatch(setTelephonyDirectory(res.data.getHotelTelephonyDetails.directories));
    dispatch(setTelephonyExtensions(res.data.getHotelTelephonyDetails.extensions));
  } catch (error) {
    logError(hotelId, 'fetchAllTelephonyDetails', error?.message);

    if (ENVIRONMENT === 'dev') {
      console.log(error?.message);
    }
    return false;
  } finally {
    dispatch(stepDownLoaderCount());
  }
};

export const fetchAllNotifications = (hotelId) => async (dispatch) => {
  try {
    dispatch(stepUpLoaderCount());
    const lang = decryptLocalStorage('lang');
    const getByLang = lang !== 'en' ? lang : '';
    const pillInactive = 'pill-inactive';
    const pillActive = 'pill-active';
    const pillScheduled = 'scheduled';

    const res = await getCampaignNotifications(hotelId, getByLang);
    const notificationDetails = res.data.getCampaignOffersDetails.map((item) => {
      const oneTimeScheduleDate = item?.offerSchedule?.oneTimeSchedule?.date;
      const oneTimeScheduleTime = item?.offerSchedule?.oneTimeSchedule?.time;
      const repeatScheduleTime = item?.offerSchedule?.repeatSchedule?.time;
      const repeatScheduleTo = item?.offerSchedule?.repeatSchedule?.to;
      const repeatScheduleFrom = item?.offerSchedule?.repeatSchedule?.from;

      const repeatScheduleEndTime = `${repeatScheduleTo || moment().format('DD-MM-YYYY')} ${
        repeatScheduleTime ? repeatScheduleTime : '23:59'
      }`;

      const oneTimeScheduleEndTime = `${oneTimeScheduleDate || moment().format('DD-MM-YYYY')} ${
        oneTimeScheduleTime ? oneTimeScheduleTime : '23:59'
      }`;

      const calculateStartTime = (from, time) => `${from} ${time ? time : '00:00'}`;

      let status = '';
      let statusClass = '';
      let startTime, isBefore, isAfter;

      if (item?.offerSchedule?.schedule === 'Instant') {
        status = Completed;
        statusClass = 'pill-inactive';
        return { ...item, status, statusClass };
      }

      if (item?.isActive) {
        if (oneTimeScheduleDate) {
          startTime = calculateStartTime(oneTimeScheduleDate, oneTimeScheduleTime);
          isBefore = moment(startTime, 'DD-MM-YYYY HH:mm').isBefore(moment());
          isAfter = moment(oneTimeScheduleEndTime, 'DD-MM-YYYY HH:mm').isAfter(moment());
        } else {
          startTime = calculateStartTime(repeatScheduleFrom, repeatScheduleTime);
          isBefore = moment(startTime, 'DD-MM-YYYY HH:mm').isBefore(moment());
          isAfter = moment(repeatScheduleEndTime, 'DD-MM-YYYY HH:mm').isAfter(moment());
        }

        if (isAfter && isBefore) {
          status = Live;
          statusClass = pillActive;
        } else if (isBefore && !isAfter) {
          status = Completed;
          statusClass = pillInactive;
        } else if (!isBefore && isAfter) {
          status = Scheduled;
          statusClass = pillScheduled;
        }
      } else if (!item?.isActive) {
        if (oneTimeScheduleDate) {
          const endTime = oneTimeScheduleEndTime;
          isBefore = moment(endTime, 'DD-MM-YYYY HH:mm').isBefore(moment());
          status = isBefore ? Completed : Deactivated;
          statusClass = pillInactive;
        } else {
          isBefore = moment(repeatScheduleEndTime, 'DD-MM-YYYY HH:mm').isBefore(moment());
          status = isBefore ? Completed : Deactivated;
          statusClass = pillInactive;
        }
      }

      return { ...item, status, statusClass };
    });
    dispatch(setNotificationCampaign(notificationDetails));
  } catch (error) {
    logError(hotelId, 'fetchAllNotifications', error?.message);

    if (ENVIRONMENT === 'dev') {
      console.log(error?.message);
    }
  } finally {
    dispatch(stepDownLoaderCount());
  }
};

export const fetchAllEmailServices = (hotelId) => async (dispatch) => {
  try {
    dispatch(stepUpLoaderCount());
    const lang = decryptLocalStorage('lang');
    const getByLang = lang !== 'en' ? lang : '';
    const res = await getEmailServicesList(hotelId, getByLang);
    if (res?.data?.getEmailServicesDetails) {
      dispatch(setEmailServices(res.data.getEmailServicesDetails));
    } else {
      dispatch(setEmailServices([]));
    }
  } catch (error) {
    logError(hotelId, 'fetchAllEmailServices', error?.message);

    if (ENVIRONMENT === 'dev') {
      console.log(error?.message);
    }
    dispatch(setEmailServices([]));
    return false;
  } finally {
    dispatch(stepDownLoaderCount());
  }
};

export const serviceRequestSelector = (state) => state.service.serviceRequest;
export const allHouseKeeping = (state) => state.service.serviceRequestHouseKeeping;
export const allConcierge = (state) => state.service.serviceRequestConcierge;
export const inRoomDiningCategorySelector = (state) => state.service.inRoomDiningCategory;
export const inRoomDiningLoaderSelector = (state) => state.service.inRoomDiningLoader;
export const inRoomDiningItemsSelector = (state) => state.service.inRoomDiningItems;
export const inRoomDiningCustomisationsSelector = (state) =>
  state.service.inRoomDiningCustomisations;
export const inRoomDiningTagsSelector = (state) => state.service.inRoomDiningTags;
export const inRoomDiningAllergensSelector = (state) => state.service.inRoomDiningAllergens;
export const inRoomDiningAddOnSelector = (state) => state.service.inRoomDiningAddOn;
export const inRoomDiningDiscountsSelector = (state) => state.service.inRoomDiningDiscounts;
export const inRoomDiningKindsSelector = (state) => state.service.inRoomDiningKinds;
export const inRoomDiningCombosSelector = (state) => state.service.inRoomDiningCombos;
export const inRoomDiningMenuSelector = (state) => state.service.inRoomDiningMenu;
export const inRoomDiningMenuFormData = (state) => state.service.menuFormData;
export const inRoomDiningMenuIsPublishedSelector = (state) => state.service.isPublished;
export const inRoomDiningMenuIdSelector = (state) => state.service.menuId;
export const telephonyDirectoriesSelector = (state) => state.service.telephonyDirectories;
export const telephonyExtensionsSelector = (state) => state.service.telephonyExtensions;
export const campainNotificatons = (state) => state.service.notificationCampaign;
export const emailServicesSelector = (state) => state.service.emailServices;
export const menuTypeSelector = (state) => state.service.menuType;
export default servicesSlice.reducer;
